import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getPlantUnit } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetPlantUnitRequestSchema,
  type GetPlantUnitResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 電源ユニット 1 件の取得 hook (詳細ページ)。返る `updatedAt` を更新の `expectedUpdatedAt`
 * (楽観ロック) に渡す。`id` が undefined または空文字の時は query を無効化する。
 *
 * - `throwOnError: false`: 取得失敗 (他の利用者が削除した NotFound 等) は画面内に出す。
 *   QueryClient 既定の `throwOnError: true` のままだと画面全体のエラーになる
 * - `gcTime: 0`: 画面を離れたら結果を捨て、開くたびに最新が届くまで入力を始めさせない
 *   (前回の結果が残っていると、取り直し中に古い値で入力・保存できてしまう)
 */
export function useGetPlantUnit(
  id: string | undefined,
): UseQueryResult<GetPlantUnitResponse, ConnectError> {
  return useQuery(
    getPlantUnit,
    create(GetPlantUnitRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '', throwOnError: false, gcTime: 0 },
  )
}
